import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { SIGNATURE_TYPES } from '../../../../constant/constant';
import { ImageTransform, ImageCroppedEvent, Dimensions } from '../../../../image-cropper/interfaces';
import { base64ToFile } from '../../../../image-cropper/utils/blob.utils';
import { agreement_data } from '../../../../models/Doctorreferral';
import { LanguageSpoken } from '../../../../models/doctorregistration';
import { PromiseResult, ServerError } from '../../../../models/PromiseResult';
import { DoctorReferralService } from '../../../../services/doctor-referral.service';
import { DoctorsService } from '../../../../services/doctors.service';
import { fromEvent } from 'rxjs';
import { switchMap, takeUntil, pairwise } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@TraceClassDecorator()
@Component({
    selector: 'app-doctor-agreement',
    templateUrl: './doctor-agreement.component.html',
    styleUrls: ['./doctor-agreement.component.css']
})
export class DoctorAgreementComponent implements OnInit {
    @ViewChild("canvas") public canvas: ElementRef<HTMLCanvasElement>;
    @Input() public width = 300;
    @Input() public height = 70;
    slug: string = "";
    logo_url: string = "";
    constructor(
        private readonly doctorService: DoctorsService,
        private readonly referral: DoctorReferralService,
        private readonly sanitizer: DomSanitizer,
        private readonly router: Router,
        private readonly titleService: Title,
        private readonly providerstateService: ProviderStateService
    ) {

        this.toBlob = () =>
            new Promise((resolve, reject) => {
                this.canvas.nativeElement.toBlob((blob: Blob) => {
                    if (blob != null) {
                        resolve(blob);
                    }
                    else {
                        reject(blob);
                    }
                })
            })
    }


    private cx: CanvasRenderingContext2D;
    signatureOptionSelected: string = null;
    signatureDialog: boolean = false;
    signatureFile = null;
    imageChangedEvent: any = "";
    croppedImage: any = "";
    canvasRotation = 0;
    rotation = 0;
    scale = 1;
    showCropper = false;
    containWithinAspectRatio = false;
    transform: ImageTransform = {};
    languages: LanguageSpoken[] = [];
    selected_language = [];
    signature_file_name = '';
    signature_file_type_error: boolean = false;
    agreement: agreement_data = new agreement_data();
    response: PromiseResult = new PromiseResult();
    serverError = new ServerError();
    posting = false;
    agreement_success: boolean = false;
    has_signed: boolean = false;

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.logo_url = this.providerstateService.getLogoUrl();
        this.titleService.setTitle("Doctor Agreement");
        await this.fetchAgreement();
    }

    async fetchAgreement(): Promise<void> {
        this.posting = true;
        await this.doctorService.fetchAgreement()
            .toPromise()
            .then(result => {
                this.response = result;
                if (result.success) {
                    this.agreement.document_body = this.sanitizer.bypassSecurityTrustHtml(result.data.agreement.document_body);
                    this.agreement.document_id = result.data.agreement.document_id;
                }

            })
            .catch((error) => {
                this.serverError = error.error;
                this.response.success = false;

            })
        this.posting = false;
    }

    async submit(): Promise<void> {
        this.posting = true;
        if (this.signatureOptionSelected == 'draw') {
            await this.print();
        }
        else if (this.signatureOptionSelected == 'upload') {
            await this.blobToImageUpload(this.signatureFile);
        }
        this.posting = false;

    }
    fileChangeEvent(event: any): void {
        // debugger;

        this.imageChangedEvent = event;
        if (SIGNATURE_TYPES.includes(event.target.files[0].type.toString())) {
            this.signature_file_type_error = false;
            this.signature_file_name = event.target.files[0].name
            this.signatureFile = event.target.files[0];
            this.has_signed = true;
        }
        else {
            this.signature_file_type_error = true;
            this.imageChangedEvent = "";
            this.croppedImage = "";
            this.canvasRotation = 0;
            this.rotation = 0;
            this.scale = 1;
            this.showCropper = false;
            this.containWithinAspectRatio = false;
            this.transform = {};
            this.signature_file_name = "";
        }
    }

    imageCropped(event: ImageCroppedEvent) {

        this.croppedImage = event.base64;

        this.signatureFile = base64ToFile(event.base64);
    }

    imageLoaded() {

        this.showCropper = true;

    }

    cropperReady(sourceImageDimensions: Dimensions) {

    }

    loadImageFailed() {

    }

    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }

    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
    }

    flipHorizontal() {
        this.transform = {
            ...this.transform,
            flipH: !this.transform.flipH
        };
    }

    flipVertical() {
        this.transform = {
            ...this.transform,
            flipV: !this.transform.flipV
        };
    }

    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }

    zoomOut() {
        this.scale -= 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomIn() {
        this.scale += 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }

    updateRotation() {
        this.transform = {
            ...this.transform,
            rotate: this.rotation
        };
    }

    addSignature() {
        this.showCropper = false;
        this.signature_file_type_error = false;
        this.signatureDialog = true;


    }

    saveSignature() {
        this.signatureDialog = false;

    }


    public ngAfterViewInit() {
        // const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        // this.cx = canvasEl.getContext("2d");

        // canvasEl.width = this.width;
        // canvasEl.height = this.height;

        // this.cx.lineWidth = 3;
        // this.cx.lineCap = "round";
        // this.cx.strokeStyle = "#000";

        // this.captureEvents(canvasEl);
        // canvasEl.toBlob((res)=>{

        // })
    }

    private async captureEvents(canvasEl: HTMLCanvasElement) {
        // this will capture all mousedown events from the canvas element

        fromEvent(canvasEl, "mousedown")
            .pipe(
                switchMap((e) => {
                    // after a mouse down, we'll record all mouse moves
                    return fromEvent(canvasEl, "mousemove").pipe(
                        // we'll stop (and unsubscribe) once the user releases the mouse
                        // this will trigger a 'mouseup' event
                        takeUntil(fromEvent(canvasEl, "mouseup")),
                        // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
                        takeUntil(fromEvent(canvasEl, "mouseleave")),
                        // pairwise lets us get the previous value to draw a line from
                        // the previous point to the current point
                        pairwise()
                    );
                })
            )
            .subscribe(async (res: [MouseEvent, MouseEvent]) => {
                const rect = canvasEl.getBoundingClientRect();

                // previous and current position with the offset
                const prevPos = {
                    x: res[0].clientX - rect.left,
                    y: res[0].clientY - rect.top,
                };

                const currentPos = {
                    x: res[1].clientX - rect.left,
                    y: res[1].clientY - rect.top,
                };
                this.has_signed = true;
                // this method we'll implement soon to do the actual drawing
                this.drawOnCanvas(prevPos, currentPos);

            });
    }

    private drawOnCanvas(
        prevPos: { x: number; y: number },
        currentPos: { x: number; y: number }
    ) {
        if (!this.cx) {
            return;
        }

        this.cx.beginPath();

        if (prevPos) {
            this.cx.moveTo(prevPos.x, prevPos.y); // from
            this.cx.lineTo(currentPos.x, currentPos.y);
            this.cx.stroke();
        }
    }
    private readonly toBlob;
    async print() {
        const blob = await this.toBlob();
        const file: File = new File([blob], "signature.png", { type: "image/png", lastModified: new Date().valueOf() });
        await this.upload(file);

    }
    async blobToImageUpload(blob: Blob) {
        const file = new File([blob], "signature.png", { type: "image/png", lastModified: new Date().valueOf() });
        await this.upload(file);

    }

    private async upload(file: File): Promise<void> {
        this.response = new PromiseResult();
        this.serverError = new ServerError();
        const form: FormData = new FormData()
        form.set('file', file);
        form.set('document_id', this.agreement.document_id);
        await this.referral.signAgreement(form)
            .toPromise()
            .then(result => {
                this.response = result;
                this.agreement_success = result.success;
            })
            .catch((error) => {
                this.serverError = error.error;
                this.response.success = false;
            })
        this.posting = false;

    }

    gotodashboard() {
        this.router.navigate(['/' + this.slug + '/doctor/dashboard']);
    }

    changeSignatureOption() {
        this.has_signed = false;
        if (this.signatureOptionSelected == 'draw') {
            const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
            this.cx = canvasEl.getContext("2d");
            canvasEl.width = this.width;
            canvasEl.height = this.height;
            this.cx.lineWidth = 3;
            this.cx.lineCap = "round";
            this.cx.strokeStyle = "#000";
            this.captureEvents(canvasEl);
            canvasEl.toBlob((res) => {

            })

        }
        this.imageChangedEvent = "";
        this.croppedImage = "";
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.showCropper = false;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.signature_file_name = "";
    }

    clearSignatureDraw() {
        this.has_signed = false;
        const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        this.cx = canvasEl.getContext("2d");
        canvasEl.width = this.width;
        canvasEl.height = this.height;
        this.cx.lineWidth = 3;
        this.cx.lineCap = "round";
        this.cx.strokeStyle = "#000";
        this.captureEvents(canvasEl);
        canvasEl.toBlob((res) => {

        });

    }

    close() {
        this.signatureDialog = false;
    }


}
